import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import measurementTypes from '../../lib/MeasurementTypes'
import measurementUnits from '../../lib/MeasurementUnit'
import measurementUtil from '../../lib/MeasurementUtil'
import measurementVisibility from '../../lib/MeasurementVisibility'
import measurementChannels from "../../lib/MeasurementChannel";

let MeasurementStore = class {
    constructor() {

        this.state = {

            current: null,

            isLoading: false,

            averageInterval: 10,

            availableMeasurements: [],
            selectedMeasurements: [],

        };

        this.getters = {

            current:(state) => state.current,

            averageInterval:(state) => state.averageInterval,

            isLoading:(state) => state.isLoading,

            availableMeasurements:(state) => state.availableMeasurements,
            selectedMeasurements:(state) => state.selectedMeasurements,
        };

        this.mutations = {
            setIsLoading (state, model) {
                state.isLoading = model
            },
            setAverageInternal (state, value ) {
                state.averageInterval = value;
            },
            setSelectedMeasurements(state, value) {
                state.selectedMeasurements = value;
            },
            setAvailableMeasurements(state, value) {
                state.availableMeasurements = value;
            },

            setCurrent (state, updateValue ) {
                state.current = updateValue;
            },

            updateLogData(state, updateValue) {
                if(state.current)
                    state.current.logData = updateValue;
            },

            updateProtocolData(state, updateValue) {
                if(state.current)
                    state.current.protocolData = updateValue;
            },

            updateElapsedTime (state, updateValue ) {
                state.current.elapsedSeconds = updateValue;
            },

            updateMeasurement (state, updateValues ) {

                let current = state.current;

                for(let item of updateValues) {

                    let existing = current.data.find(x => x.id === item.id);
                    if (!existing) {

                        current.data.push(item);

                        if (measurementVisibility.visibleToUser(item.measurementType)) {

                            let isAvailable = state.availableMeasurements.find( x => measurementTypes.match(x.value, item.measurementType)) !== undefined;

                            //filter VO2 vs VO2 by weight, don't need both.
                            let isVo2 = measurementTypes.match(item.id, measurementTypes.OxygenConsumption);
                            //let isVo2ByWeight = measurementTypes.match(item.id, measurementTypes.OxygenConsumptionByWeight);
                            let isVco2 = measurementTypes.match(item.id, measurementTypes.CarbonDioxideProduction);
                            //let isVco2ByWeight = measurementTypes.match(item.id, measurementTypes.CarbonDioxideProductionByWeight);

                            if (!isAvailable) {

                                //add new item to available
                                state.availableMeasurements.push({
                                    text: item.measurementNameExtended,
                                    value: item.measurementType,
                                    order: item.order
                                });

                                //select by default
                                if (!state.selectedMeasurements.includes(item.measurementType)) {
                                    state.selectedMeasurements.push(item.measurementType);
                                }
                            }

                            if (isVo2 && current.data.find(x => measurementTypes.match(x.measurementType, measurementTypes.OxygenConsumptionByWeight))) {
                                state.selectedMeasurements = state.selectedMeasurements.filter(x => !measurementTypes.match(x, measurementTypes.OxygenConsumption));
                            }
                            if (isVco2 && current.data.find(x => measurementTypes.match(x.measurementType, measurementTypes.CarbonDioxideProductionByWeight))) {
                                state.selectedMeasurements = state.selectedMeasurements.filter(x => !measurementTypes.match(x, measurementTypes.CarbonDioxideProduction));
                            }

                            state.availableMeasurements.sort((a, b) => a.order - b.order);
                        }


                    } else {
                        existing.elapsedSeconds = item.elapsedSeconds;
                        existing.points = item.points;
                        existing.averagedPoints = item.averagedPoints;
                        existing.chartData = item.chartData;
                        existing.metrics = item.metrics;
                    }
                }

                current.data.sort((a, b) => a.order - b.order);
            },

        };

        this.actions = {

            update ({ state, commit }, updateValue ) {

                commit('setIsLoading', true);

                let current = state.current;
                let availableMeasurements = state.availableMeasurements;
                let selectedMeasurements = state.selectedMeasurements;

                if(!current || !updateValue || updateValue.sessionId != current.sessionId) {

                    current = {
                        sessionId: 0,
                        elapsedSeconds: 0,
                        data: [],
                        logData: [],
                        protocolData: {
                            steps: [],
                            phases:[]
                        },
                    };

                    if(updateValue) {
                        current.sessionId = updateValue.sessionId;
                    }

                    availableMeasurements = [];
                    selectedMeasurements = [];

                    commit('setCurrent', current);
                    commit('setAvailableMeasurements', availableMeasurements);
                    commit('setSelectedMeasurements', selectedMeasurements);
                }

                if(updateValue) {

                    let elapsedSeconds = 0;
                    if(updateValue && updateValue.elapsedTimeMilliseconds) {
                        elapsedSeconds = updateValue.elapsedTimeMilliseconds / 1000; //ms to seconds
                    }

                    commit('updateElapsedTime', elapsedSeconds);

                    if(updateValue.logData) {
                        commit('updateLogData', updateValue.logData);
                    }

                    if(updateValue.protocolData) {
                        let protocolData = measurementUtil.calculateProtocolPhases(updateValue.protocolData, elapsedSeconds);
                        commit('updateProtocolData', protocolData);
                    }

                    if(updateValue.data) {

                        let updateItems = [];
                        let data = updateValue.data;

                        data.forEach(function (measurement) {

                            let measurementChannel = measurement.c;
                            let measurementType = measurementTypes.find(measurement.t);
                            let measurementUnit = measurementUnits.find(measurement.u);
                            let measurementPoints = measurement.p;

                            let measurementId = measurementTypes.createIdentifier( measurementType, measurementChannel);
                            let measurementName = measurementType.label;
                            let measurementShortName = measurementType.short;
                            let measurementNameExtended = measurementName;
                            let measurementUnitName = '';

                            //apply channel id
                            if (measurementChannel && !measurementChannels.match(measurementChannel, measurementChannels.Default)) {
                                measurementName += '-' + measurementChannel;
                                measurementShortName += '-' + measurementChannel;
                                measurementNameExtended += '-' + measurementChannel;
                            }

                                //add new item
                                //build friendly names
                                if(measurementType.short) {
                                    let short = measurementType.short;
                                    if(measurementType.label == measurementType.short)
                                        short = '';
                                    if (measurementUnit && measurementUnit.short && measurementUnit.short != '')
                                        short += ' ' + measurementUnit.short;
                                    measurementNameExtended += ' (' + short + ')';
                                }

                                if (measurementUnit && measurementUnit.short && measurementUnit.short != '') {
                                    measurementUnitName = measurementUnit.short;
                                    measurementName += ' [ ' + measurementUnitName + ' ]';
                                }

                                //create measurement data item
                                let item = {
                                    id: measurementId,
                                    elapsedSeconds: elapsedSeconds,
                                    measurementType: measurementType,
                                    measurementChannel: measurementChannel,
                                    measurementUnit: measurementUnit,
                                    order: measurementType.order,
                                    color: measurementType.color,
                                    fill: measurementType.fill ?? false,
                                    fillColor: measurementType.fillColor ?? measurementType.color,
                                    yAxisPosition: measurementType.yAxisPosition ?? "left",
                                    decimals: measurementType.decimals,
                                    name: measurementName,
                                    shortName: measurementShortName,
                                    unitsName: measurementUnitName,
                                    shortNameWithUnits: measurementShortName + (measurementUnitName ? ' [' + measurementUnitName + ']' : ''),
                                    measurementNameExtended: measurementNameExtended,
                                    points: [],
                                    averagedPoints: [],
                                    chartData: [],
                                    metrics: {
                                        last: 0,
                                        min: 0,
                                        max: 0,
                                        average: 0
                                    }
                                };


                                item.elapsedSeconds = elapsedSeconds;

                                if (measurementPoints) {
                                    item.points = measurementPoints;

                                    //expand t,v => time,value
                                    item.points.forEach(function (val) {
                                        if (val.v !== undefined)
                                            val.value = val.v;

                                        if (val.t !== undefined)
                                            val.time = val.t;
                                        if(val.time)
                                            val.time = val.time / 1000; //ms to seconds
                                    });

                                    item.averagedPoints = measurementUtil.calculateAverage(item.points, state.averageInterval, elapsedSeconds, item.decimals, item.measurementType);
                                    item.metrics = measurementUtil.calculateMetrics(item.averagedPoints, item.measurementType);

                                    //expand into chart data point format
                                    item.chartData = [];

                                    let sourcePoints = item.averagedPoints;
                                    if( measurementTypes.match(item.measurementType, measurementTypes.StepSpeedIntensity) ||
                                        measurementTypes.match(item.measurementType, measurementTypes.StepPowerIntensity) ||
                                        measurementTypes.match(item.measurementType, measurementTypes.StepInclination)) {
                                        //step values don't change often.
                                        sourcePoints = measurementUtil.filterDuplicates(item.points, item.decimals);
                                    }
                                    sourcePoints.forEach(function (val) {
                                        item.chartData.push([val.time, val.value]);
                                    });

                                updateItems.push(item);
                            }
                        });

                        commit('updateMeasurement', updateItems);
                    }
                }

                commit('setIsLoading', false);
            },

            changeSelectedMeasurements ({ commit }, selected ) {
                commit('setSelectedMeasurements', selected);
            },

            changeAverageInterval ({ state, commit }, interval ) {

                commit('setIsLoading', true);

                let current = state.current;

                if(current && current.data) {

                    let updateItems = [];
                    current.data.forEach(function (item) {
                        let updateItem = {
                           id: item.id,
                           elapsedSeconds: item.elapsedSeconds,
                           measurementType:  item.measurementType,
                           measurementChannel:  item.measurementChannel,
                           points: item.points,
                           chartData: []
                        }
                        updateItem.averagedPoints = measurementUtil.calculateAverage(item.points, interval, current.elapsedSeconds);

                        let sourcePoints = updateItem.averagedPoints;
                        if( measurementTypes.match(item.measurementType, measurementTypes.StepSpeedIntensity) ||
                            measurementTypes.match(item.measurementType, measurementTypes.StepPowerIntensity) ||
                            measurementTypes.match(item.measurementType, measurementTypes.StepInclination)) {
                            sourcePoints = measurementUtil.filterDuplicates(item.points, item.decimals);
                        }
                        sourcePoints.forEach(function (val) {
                            updateItem.chartData.push([val.time, val.value]);
                        });
                        updateItems.push(updateItem);
                    });

                    commit('updateMeasurement', updateItems);
                }

                commit('setAverageInternal', interval);
                commit('setIsLoading', false);
            }

        };
    }
}


let store = new MeasurementStore();

const state = {
    ...store.state,
};
const getters = {
    ...store.getters,
};
const actions = {
    ...store.actions,
};
const mutations = {
    ...store.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};